// src/pages/HomeScreen.js
import React, { useState } from 'react';
import './HomeScreen.css';
import api from '../services/api';

export default function HomeScreen() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.subscribeEmail(email);
      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div className="welcome-card">
      <h1 className="title">AI Agent Marketplace</h1>
      <p className="subtitle">Welcome to agentmarkets.ai</p>
      <p className="description">
        Discover, integrate, and monetize best-in-class AI agents tailored to your business needs.  
        No code required—just pick, plug, and start automating.
      </p>

      <ul className="features">
        <li>🔍 Explore top-rated AI agents</li>
        <li>⚙️ One-click integration</li>
        <li>💼 Enterprise-ready solutions</li>
        <li>📈 Scale your workflows with intelligent automation</li>
      </ul>

      <form className="email-form" onSubmit={handleSubmit}>
        <input
          type="email"
          className="email-input"
          placeholder="Enter your email to get notified"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-primary">
          Notify Me
        </button>
      </form>

      {status === 'success' && (
        <p className="status success">Thank you! We’ll notify you at {email || 'your email'}.</p>
      )}
      {status === 'error' && (
        <p className="status error">Oops! Something went wrong. Please try again.</p>
      )}
    </div>
  );
}
